export default [
   {
      "state": "Alabama",
      "abbr": "AL",
      "txt": "Alabama (AL)"
   },
   {
      "state": "Alaska",
      "abbr": "AK",
      "txt": "Alaska (AK)"
   },
   {
      "state": "Arizona",
      "abbr": "AZ",
      "txt": "Arizona (AZ)"
   },
   {
      "state": "Arkansas",
      "abbr": "AR",
      "txt": "Arkansas (AR)"
   },
   {
      "state": "California",
      "abbr": "CA",
      "txt": "California (CA)"
   },
   {
      "state": "Colorado",
      "abbr": "CO",
      "txt": "Colorado (CO)"
   },
   {
      "state": "Connecticut",
      "abbr": "CT",
      "txt": "Connecticut (CT)"
   },
   {
      "state": "Delaware",
      "abbr": "DE",
      "txt": "Delaware (DE)"
   },
   {
      "state": "District of Columbia",
      "abbr": "DC",
      "txt": "District of Columbia (DC)"
   },
   {
      "state": "Florida",
      "abbr": "FL",
      "txt": "Florida (FL)"
   },
   {
      "state": "Georgia",
      "abbr": "GA",
      "txt": "Georgia (GA)"
   },
   {
      "state": "Hawaii",
      "abbr": "HI",
      "txt": "Hawaii (HI)"
   },
   {
      "state": "Idaho",
      "abbr": "ID",
      "txt": "Idaho (ID)"
   },
   {
      "state": "Illinois",
      "abbr": "IL",
      "txt": "Illinois (IL)"
   },
   {
      "state": "Indiana",
      "abbr": "IN",
      "txt": "Indiana (IN)"
   },
   {
      "state": "Iowa",
      "abbr": "IA",
      "txt": "Iowa (IA)"
   },
   {
      "state": "Kansas",
      "abbr": "KS",
      "txt": "Kansas (KS)"
   },
   {
      "state": "Kentucky",
      "abbr": "KY",
      "txt": "Kentucky (KY)"
   },
   {
      "state": "Louisiana",
      "abbr": "LA",
      "txt": "Louisiana (LA)"
   },
   {
      "state": "Maine",
      "abbr": "ME",
      "txt": "Maine (ME)"
   },
   {
      "state": "Maryland",
      "abbr": "MD",
      "txt": "Maryland (MD)"
   },
   {
      "state": "Massachusetts",
      "abbr": "MA",
      "txt": "Massachusetts (MA)"
   },
   {
      "state": "Michigan",
      "abbr": "MI",
      "txt": "Michigan (MI)"
   },
   {
      "state": "Minnesota",
      "abbr": "MN",
      "txt": "Minnesota (MN)"
   },
   {
      "state": "Mississippi",
      "abbr": "MS",
      "txt": "Mississippi (MS)"
   },
   {
      "state": "Missouri",
      "abbr": "MO",
      "txt": "Missouri (MO)"
   },
   {
      "state": "Montana",
      "abbr": "MT",
      "txt": "Montana (MT)"
   },
   {
      "state": "Nebraska",
      "abbr": "NE",
      "txt": "Nebraska (NE)"
   },
   {
      "state": "Nevada",
      "abbr": "NV",
      "txt": "Nevada (NV)"
   },
   {
      "state": "New Hampshire",
      "abbr": "NH",
      "txt": "New Hampshire (NH)"
   },
   {
      "state": "New Jersey",
      "abbr": "NJ",
      "txt": "New Jersey (NJ)"
   },
   {
      "state": "New Mexico",
      "abbr": "NM",
      "txt": "New Mexico (NM)"
   },
   {
      "state": "New York",
      "abbr": "NY",
      "txt": "New York (NY)"
   },
   {
      "state": "North Carolina",
      "abbr": "NC",
      "txt": "North Carolina (NC)"
   },
   {
      "state": "North Dakota",
      "abbr": "ND",
      "txt": "North Dakota (ND)"
   },
   {
      "state": "Ohio",
      "abbr": "OH",
      "txt": "Ohio (OH)"
   },
   {
      "state": "Oklahoma",
      "abbr": "OK",
      "txt": "Oklahoma (OK)"
   },
   {
      "state": "Oregon",
      "abbr": "OR",
      "txt": "Oregon (OR)"
   },
   {
      "state": "Pennsylvania",
      "abbr": "PA",
      "txt": "Pennsylvania (PA)"
   },
   {
      "state": "Rhode Island",
      "abbr": "RI",
      "txt": "Rhode Island (RI)"
   },
   {
      "state": "South Carolina",
      "abbr": "SC",
      "txt": "South Carolina (SC)"
   },
   {
      "state": "South Dakota",
      "abbr": "SD",
      "txt": "South Dakota (SD)"
   },
   {
      "state": "Tennessee",
      "abbr": "TN",
      "txt": "Tennessee (TN)"
   },
   {
      "state": "Texas",
      "abbr": "TX",
      "txt": "Texas (TX)"
   },
   {
      "state": "Utah",
      "abbr": "UT",
      "txt": "Utah (UT)"
   },
   {
      "state": "Vermont",
      "abbr": "VT",
      "txt": "Vermont (VT)"
   },
   {
      "state": "Virginia",
      "abbr": "VA",
      "txt": "Virginia (VA)"
   },
   {
      "state": "Washington",
      "abbr": "WA",
      "txt": "Washington (WA)"
   },
   {
      "state": "West Virginia",
      "abbr": "WV",
      "txt": "West Virginia (WV)"
   },
   {
      "state": "Wisconsin",
      "abbr": "WI",
      "txt": "Wisconsin (WI)"
   },
   {
      "state": "Wyoming",
      "abbr": "WY",
      "txt": "Wyoming (WY)"
   }
];